export const FIRST_PURCHASE_UPLOADED_USERS_KEY = "first_purchase_uploaded_users";

export const getFirstPurchaseUserKey = (userInfo) => {
  if (!userInfo) {
    return "";
  }
  if (userInfo.rid) {
    return `rid:${userInfo.rid}`;
  }
  if (userInfo.money && userInfo.money.rid) {
    return `rid:${userInfo.money.rid}`;
  }
  if (userInfo.phone) {
    return `phone:${userInfo.phone}`;
  }
  if (userInfo.rolename) {
    return `rolename:${userInfo.rolename}`;
  }
  if (userInfo.token) {
    return `token:${userInfo.token}`;
  }
  return "";
};

export const getFirstPurchaseUploadedUsers = (getPersist) => {
  const uploadedUsers = getPersist(FIRST_PURCHASE_UPLOADED_USERS_KEY);
  if (
    uploadedUsers &&
    typeof uploadedUsers === "object" &&
    !Array.isArray(uploadedUsers)
  ) {
    return uploadedUsers;
  }
  return {};
};

export const markFirstPurchaseUploaded = (
  userInfo,
  orderId,
  getPersist,
  setPersist,
  source = ""
) => {
  const userKey = getFirstPurchaseUserKey(userInfo);
  if (!userKey) {
    console.log("[FirstPurchaseAttribution] skip mark uploaded: missing user key", {
      order_id: orderId,
      source,
    });
    return false;
  }

  const uploadedUsers = getFirstPurchaseUploadedUsers(getPersist);
  setPersist(FIRST_PURCHASE_UPLOADED_USERS_KEY, {
    ...uploadedUsers,
    [userKey]: {
      order_id: orderId,
      uploaded_at: Date.now(),
      source,
    },
  });
  console.log("[FirstPurchaseAttribution] mark uploaded", {
    user_key: userKey,
    order_id: orderId,
    source,
  });
  return true;
};
